(function () {
  if (window.__gemstonePriceSyncLoaded) return;
  window.__gemstonePriceSyncLoaded = true;

  function tierNameForTotal(total) {
    if (total === 0) return "No Premium Stones";
    return "+$" + total;
  }

  function computeTotal() {
    var selects = document.querySelectorAll(".__gemstone-select");
    var total = 0;
    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      var surcharge = opt ? parseInt(opt.getAttribute("data-surcharge") || "0", 10) : 0;
      total += surcharge;
    });
    return total;
  }

  function syncStoneTier() {
    var total = computeTotal();
    var tierName = tierNameForTotal(total);
    var radios = document.querySelectorAll('input[data-option-name="Stone Tier"]');
    radios.forEach(function (radio) {
      if (radio.value === tierName && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        radio.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }

  function attachListeners() {
    var selects = document.querySelectorAll(".__gemstone-select");
    if (selects.length === 0) return;
    selects.forEach(function (sel) {
      sel.addEventListener("change", syncStoneTier);
    });
    syncStoneTier();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachListeners);
  } else {
    attachListeners();
  }
})();
